import InputUncontrolled from "../../components/InputUncontrolled";
import SelectUncontrolled from "../../components/SelectUncontrolled";

export default function BirthdayFields({ data, errors }) {
	return (
		<div className="three">
			<div>
				<SelectUncontrolled
					label="Month"
					req={true}
					name="month"
					value={data.month}
					data={[{ value: "", name: "--" }].concat(
						[
							"January",
							"February",
							"March",
							"April",
							"May",
							"June",
							"July",
							"August",
							"September",
							"October",
							"November",
							"December",
						].map((month, index) => {
							return { value: index + 1, name: month };
						}),
					)}
					errors={errors}
					autocomplete="bday-month"
				/>
			</div>

			<div>
				<SelectUncontrolled
					label="Day"
					req={true}
					name="day"
					value={data.day}
					data={[
						{
							value: "",
							name: "--",
						},
					].concat(
						Array(31)
							.fill()
							.map((_, index) => index + 1)
							.map((item) => {
								return {
									name: item,
									value: item,
								};
							}),
					)}
					errors={errors}
					autocomplete="bday-day"
				/>
			</div>
			<div>
				<InputUncontrolled
					type="text"
					label="Year"
					req={true}
					name="year"
					value={data.year}
					errors={errors}
					autocomplete="bday-year"
				/>
			</div>
		</div>
	);
}
